import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; 

import './styles/all.css';
import './styles/index.css';
import './styles/nav.css';
import './styles/contact.css';
import './styles/resume.css';


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

